// extracted by mini-css-extract-plugin
export default {"addressInputsGroup":"OfQGh5_vC65lNbHxEOHj"};